<script setup lang="ts">
import {
  Modal as AModal,
  Spin as ASpin
} from 'ant-design-vue'

import XmAgentAndIndustryForm from './xm-tenant-and-industry-form.vue'

import { useXmTenantAndIndustryModalStore } from '../stores/xm-tenant-and-industry-modal'

const XmAgentAndIndustryModalStore = useXmTenantAndIndustryModalStore()

const {
  modalProps,
  loading
} = storeToRefs(XmAgentAndIndustryModalStore)

const {
  onCancel,
  onOk
} = XmAgentAndIndustryModalStore
</script>

<template>
  <AModal v-bind="modalProps" @cancel="onCancel" @ok="onOk">
    <ASpin :spinning="loading">
      <XmAgentAndIndustryForm />
    </ASpin>
  </AModal>
</template>
